$(document).ready(function () {


    function getState(pc) {

var rang =  {"NSW":[1000,2599,2619,2898,2921,2999],"ACT":[200,299,2600,2618,2900,2920],"VIC":[3000,3999,8000,8999],"QLD":[4000,4999,9000,9999],"SA":[5000,5999],"WA":[6000,6797,6800,6999],"TAS":[7000,7999],"NT":[0800,0999]} ;

var exp =  {"0872":"NT","2540":"NSW","2611":"ACT","2620":"NSW","3500":"VIC","3585":"VIC","3586":"VIC","3644":"VIC","3707":"VIC","2899":"NSW","6798":"WA","6799":"WA","7151":"TAS"} ;

if(exp[pc] !== undefined) {
    return exp[pc];
} else {
    for (var key in rang) {
        if (rang.hasOwnProperty(key)) {
        //    console.log(key + " -> " + rang[key]);
            //   console.log(Object.keys(rang[key]).length);
                for(var i = 0; i < Object.keys(rang[key]).length; i+=2) {
            //		console.log(rang[key][i], rang[key][i+1]);
                    if ( pc >= rang[key][i] && pc <= rang[key][i+1] ) {
                        return key;
                    }
                }
        }
    }
}
return '';
}

    

    $('body').on("change", "#ShippingCalculatorCountry", function (e) {
    var form = $(this).closest('.form');
    if (form.find(this).val() == 'AU') {
        form.find('#nz-province').hide();
        form.find('#au-province').show();
    } else {
        form.find('#au-province').hide();
        form.find('#nz-province').show();
    }
    });

    $('body').on("click", "#search_postcode", function (e) {
    e.preventDefault();
    var form = $(this).closest('.form');
    form.find('.ShippingEstimator__Error').hide();
    var destinations = {};
    var rate = [];
    var temp = {};
    var pc = form.find('[name="postal_code"]').val();
    var destination = {};
    destination["postal_code"] = pc;
    destination["province"] = form.find("#ShippingCalculatorCountry").val() == 'AU' ? form.find('#ShippingCalculatorAUProvince').val() : form.find('#ShippingCalculatorNZProvince').val();
    destination["country"] = form.find("#ShippingCalculatorCountry").val();
    destinations["destination"] = destination;
    temp = destinations;
    var items = [];
    
    $.get('/cart.json', function(cart) {
        if (form.closest('product-info').length > 0) {
            if ($('#productJson').length != 0) {
                var item = JSON.parse(JSON.parse(document.getElementById('productJson').textContent));
                items.push(item);
                temp["items"] = items;
            }
            temp["items"][0]["properties"] = {};
            if ($('li[rel="cs-tab1"]').hasClass('active')) {
                temp["items"][0]["properties"]['_odm'] = 'Shipping';
            } else if ($('li[rel="cs-tab2"]').hasClass('active')) {
                temp["items"][0]["properties"]['_odm'] = 'Local Delivery';
            } else {
                temp["items"][0]["properties"]['_odm'] = 'Store Pickup';
            }
            if (csJq('.iia-list').length && csJq('.iia-list').text().indexOf('Rocklea') == -1) {
                temp["items"][0]["properties"]['_ml'] = 'ml=no';
            }
        } else {
            $(cart.items).each(function(i, v) {
                var item = {};
                item = v;

                // if (i == 0) { 
                if ($('li[rel="cs-tab1"]').hasClass('active')) {
                    item["properties"]['_odm'] = 'Shipping'
                } else if ($('li[rel="cs-tab2"]').hasClass('active')) {
                    item["properties"]['_odm'] = 'Local Delivery'
                } else {
                    item["properties"]['_odm'] = 'Store Pickup'
                }
                //  } 
                items.push(item);
            });

            if (cart.items.length > 0) {
                temp["items"] = items;
            } else {
                if ($('li[rel="cs-tab1"]').hasClass('active')) {
                temp["items"] = [
                    {
                    properties: {
                        _odm: 'Shipping'
                    }
                    }
                ];
                } else if ($('li[rel="cs-tab2"]').hasClass('active')) {
                temp["items"] = [
                    {
                    properties: {
                        _odm: 'Local Delivery'
                    }
                    }
                ];
                } else {
                temp["items"] = [
                    {
                    properties: {
                        _odm: 'Store Pickup'
                    }
                    }
                ];
                }
                if (csJq('.iia-list').length && csJq('.iia-list').text().indexOf('Rocklea') == -1) {
                temp["items"][0]["properties"]['_ml'] = 'ml=no';
                }
            }
        }
        
        var shop = Shopify.shop;
        rate = temp;
        var html ='';
        form.find('#shipping_rates').html(html).hide();
        var t =  /^\d+$/.test(pc);
        if(pc.length != 4 || t==false) {
        form.find('.ShippingEstimator__Error').html('{{ settings.ship_err_req }}').show();
        return false;
        }
        $.ajax({
        url: "https://sbz.cirkleinc.com/front-widget",
        data: {rate,shop},
        dataType:'JSON',
        crossDomain: true,
        type: "post",
        success: function (srates) {
            if(form.find('#input_postcode').val() == ""){
            form.find('.ShippingEstimator__Error').html('{{ settings.ship_err_req }}').show();
            }else{
            if(typeof srates.rates == 'undefined') {
                form.find('.ShippingEstimator__Error').html('{{ settings.ship_err }}').show();
                return false;
            }
            if(srates.rates.length <= 0){
                if(form.find('#input_postcode').val() == ""){
                form.find('.ShippingEstimator__Error').html('Enter the zip code.').show();
                }else{
                if (form.find("#ShippingCalculatorCountry").val() == 'AU') {
                    form.find('.ShippingEstimator__Error').html('Enter a valid postcode for '+form.find('#ShippingCalculatorAUProvince option:selected').text()+', Australia').show();
                } else {
                    form.find('.ShippingEstimator__Error').html('Enter a valid postcode for '+form.find('#ShippingCalculatorNZProvince option:selected').text()+', New Zealand').show();
                }
                
                }

            }else{
                if (form.hasClass('no_cost')) {
                html += '<ul>';
                $(srates.rates).each(function(index,val) {
                    form.find('.ShippingEstimator__Error').hide();
                    html += '<li><span>'+val.service_name+'</span><br/><span class="shipdesc">'+val.description+'</span></li>'
                    console.log("s:", val);
                });
                html += '</ul>'
                } else {
                html += '<ul>';
                $(srates.rates).each(function(index,val) {
                    form.find('.ShippingEstimator__Error').hide();
                    html += '<li><span>'+val.service_name +' -  ' +Shopify.formatMoney(val.total_price,wmf)+'</span><br/><span class="shipdesc">'+val.description+'</span></li>'
                    console.log("s:", val);
                });
                html += '</ul>'
                }
                form.find('#shipping_rates').html(html).show();
            }
            }
        },
        });
    });
    
    });
});
